export default {"src":"/_next/static/media/masculine.2639ab4c.svg","height":50,"width":68,"blurWidth":0,"blurHeight":0};